import React from 'react';
import { SpotifyWrapper, FlowerImage } from './style.css';
import SpotifyPlayer from 'react-spotify-player';
import FlowerBg from '../../images/jpg/bg-flower.jpg';

const size = {
	width: '80%',
	height: 300
};
const view = 'coverart'; // or 'coverart'
const theme = 'black'; // or

const spotifyURL = 'spotify:album:0H6TddUF2M63ZSHGvhk5yy?si=ZWwzah2uTNS1YPPZqIfACw';

const SpotifyPlayerHolder = (props) => {
	return (
		<SpotifyWrapper>
			<FlowerImage src={FlowerBg} alt="decor flower cure" />
			<SpotifyPlayer uri={spotifyURL} size={size} view={view} theme={theme} allowtransparency={true} />
			<FlowerImage src={FlowerBg} alt="decor flower cure last" />
		</SpotifyWrapper>
	);
};

export default SpotifyPlayerHolder;
